import { FormHelperText, makeStyles } from "@material-ui/core";

import React from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "inline-block",
    float: "left",
    minHeight: 140,
  },
  help: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    maxWidth: 190,
    height: 42,
    lineHeight: "20px",
  },
}));
const InputWithTopHelpWrapper = ({ children, helperText, ...props }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <FormHelperText className={classes.help}>{helperText}</FormHelperText>
      {React.cloneElement(children, { ...props })}
    </div>
  );
};
export default InputWithTopHelpWrapper;
